import type { TFunction } from 'i18next';
import { z } from 'zod';

/** Schéma de création d'une catégorie produit pour une boutique custom. */
export function buildCustomShopCategoryFormSchema(t: TFunction) {
  return z.object({
    label: z
      .string()
      .trim()
      .min(1, t('admin.shops.categories.form.label.required'))
      .max(100, t('admin.shops.categories.form.label.max'))
  });
}

export type CustomShopCategoryFormValues = z.infer<
  ReturnType<typeof buildCustomShopCategoryFormSchema>
>;
